const mockup_internal = {
    "responseHeader": {
      "status": 0,
      "QTime": 0,
      "params": {
        "q": "*:*"
      }
    },
    "response": {
      "numFound": 2274,
      "start": 0,
      "docs": [
        {
          "id": "74f4b295-38d0-4645-96c9-caff258b76ab",
          "name": "Registro contable de compras y ventas de mercaderías. La liquidación del IVA",
          "active": true,
          "type": "book",
          "tags": [
            "mcgraw",
            "Gestión Financiera",
            "Unidad 2"
          ],
          "categories": [
            "economía",
            "contabilidad",
            "TDC",
            "TDC"
          ],
          "files": [
            "@@@dam:@application@74f4b295-38d0-4645-96c9-caff258b76ab@8e7bbb17-3ce9-471b-b32c-e8cc58d4c0fa@@@",
            "@@@dam:@application@74f4b295-38d0-4645-96c9-caff258b76ab@6f43ec26-5a22-465c-85f4-d268f5742679@@@",
            "@@@dam:@application@74f4b295-38d0-4645-96c9-caff258b76ab@4d507a56-1476-4cda-bdd9-d9272621e297@@@"
          ],
          "previews": [
            "@@@dam:@image@74f4b295-38d0-4645-96c9-caff258b76ab@7030a0c7-0812-4556-82a3-59d826229405@@@"
          ],
          "units": [
            0
          ],
          "lang": "es",
          "core_resource_type": [
            "book"
          ],
          "created_at": [
            "2021-03-04T18:01:15Z"
          ],
          "updated_at": [
            "2021-05-11T19:18:12Z"
          ],
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "220f6e31-069f-4d1b-a0c3-06e970f4f594",
          "name": "Acreedores y deudores por operaciones de tráfico",
          "active": true,
          "type": "book",
          "tags": [
            "Unidad 4"
          ],
          "categories": [
            "contabilidad",
            "TDC",
            "TDC"
          ],
          "files": [
            "@@@dam:@application@220f6e31-069f-4d1b-a0c3-06e970f4f594@4359e691-f176-42d6-9e37-2db4fafba601@@@",
            "@@@dam:@application@220f6e31-069f-4d1b-a0c3-06e970f4f594@140390ab-2c4c-4199-8d5e-84e00990928d@@@",
            "@@@dam:@application@220f6e31-069f-4d1b-a0c3-06e970f4f594@4b0a21ac-2468-4a96-8db9-02cde59fd0f6@@@"
          ],
          "previews": [
            "@@@dam:@image@220f6e31-069f-4d1b-a0c3-06e970f4f594@dc5c81e8-1afd-4978-b273-5b093503b1f5@@@"
          ],
          "units": [
            0
          ],
          "lang": "es",
          "core_resource_type": [
            "book"
          ],
          "created_at": [
            "2021-04-14T09:25:11Z"
          ],
          "updated_at": [
            "2021-05-11T18:38:02Z"
          ],
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "99acd4d9-ce3b-447e-8086-bcf5f2fdb2e1",
          "name": "150041-Activity-9788448608811",
          "active": true,
          "type": "multiple-choice",
          "tags": [
            "-Human beings on earth"
          ],
          "core_resource_type": [
            "activity"
          ],
          "created_at": [
            "2023-07-18T10:24:04Z"
          ],
          "updated_at": [
            "2023-07-18T10:24:04Z"
          ],
          "unit": [
            "1"
          ],
          "isbn": [
            "9788448608811"
          ],
          "language_default": "en-EN",
          "available_languages": [
            "en-EN"
          ],
          "assessments": [
            2504
          ],
          "xeval_id": "150041",
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "99acd4c6-5768-486b-b4f3-00c8cc8129aa",
          "name": "150043-Activity-9788448608811",
          "active": true,
          "type": "single-choice",
          "tags": [
            "-Human beings on earth"
          ],
          "core_resource_type": [
            "activity"
          ],
          "created_at": [
            "2023-07-18T10:23:51Z"
          ],
          "updated_at": [
            "2023-07-18T10:23:51Z"
          ],
          "unit": [
            "1"
          ],
          "isbn": [
            "9788448608811"
          ],
          "language_default": "en-EN",
          "available_languages": [
            "en-EN"
          ],
          "assessments": [
            2504
          ],
          "xeval_id": "150043",
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "99a36089-3019-4ffe-9f3b-af620568602a",
          "name": "2. Distribució de probabilitat d’una variable aleatòria discreta",
          "active": false,
          "type": "assessment",
          "core_resource_type": [
            "assessment"
          ],
          "created_at": [
            "2023-07-13T17:36:23Z"
          ],
          "updated_at": [
            "2023-07-13T17:36:23Z"
          ],
          "isbn": [
            "9788448639204; 9788448639211"
          ],
          "language_default": [
            "es"
          ],
          "available_languages": [
            "es"
          ],
          "xeval_id": "13782",
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "99a3601a-13ab-41de-9f69-0d38143a407a",
          "name": "6. Aproximació normal de la distribució binomial",
          "active": false,
          "type": "assessment",
          "core_resource_type": [
            "assessment"
          ],
          "created_at": [
            "2023-07-13T17:35:10Z"
          ],
          "updated_at": [
            "2023-07-13T17:35:10Z"
          ],
          "isbn": [
            "9788448639204; 9788448639211"
          ],
          "language_default": [
            "es"
          ],
          "available_languages": [
            "es"
          ],
          "xeval_id": "13786",
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "087c98f0-1537-4ca6-a928-851bf9fcd4cb",
          "name": "07_165_01.png",
          "active": true,
          "type": "image",
          "types": [
            "image"
          ],
          "tags": [
            "07"
          ],
          "categories": [
            "TDC",
            "tdc"
          ],
          "files": [
            "@@@dam:@image@087c98f0-1537-4ca6-a928-851bf9fcd4cb@8487abf4-7ee3-4fb3-97c4-7bfa2ee0f2d8@@@"
          ],
          "previews": [
            "@@@dam:@image@087c98f0-1537-4ca6-a928-851bf9fcd4cb@8487abf4-7ee3-4fb3-97c4-7bfa2ee0f2d8@@@"
          ],
          "core_resource_type": [
            "multimedia"
          ],
          "created_at": [
            "2021-04-28T18:53:38Z"
          ],
          "updated_at": [
            "2021-04-28T19:06:41Z"
          ],
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "00928fb6-22a5-4885-99f0-b0e9ccf22242",
          "name": "07_162_02.png",
          "active": true,
          "type": "image",
          "types": [
            "image"
          ],
          "tags": [
            "07"
          ],
          "categories": [
            "TDC",
            "tdc"
          ],
          "files": [
            "@@@dam:@image@00928fb6-22a5-4885-99f0-b0e9ccf22242@a2c5a195-3825-431e-8ac2-53c90f5e100e@@@"
          ],
          "previews": [
            "@@@dam:@image@00928fb6-22a5-4885-99f0-b0e9ccf22242@a2c5a195-3825-431e-8ac2-53c90f5e100e@@@"
          ],
          "core_resource_type": [
            "multimedia"
          ],
          "created_at": [
            "2021-04-28T18:23:29Z"
          ],
          "updated_at": [
            "2021-04-28T19:06:03Z"
          ],
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
        {
          "id": "09c899ba-eb83-457f-881c-7ef51e6bc044",
          "name": "05_101_01.png",
          "active": true,
          "type": "image",
          "types": [
            "image"
          ],
          "tags": [
            "05"
          ],
          "categories": [
            "TDC",
            "tdc"
          ],
          "files": [
            "@@@dam:@image@09c899ba-eb83-457f-881c-7ef51e6bc044@44f68e16-4a13-4ad6-9e67-574d05c4f820@@@"
          ],
          "previews": [
            "@@@dam:@image@09c899ba-eb83-457f-881c-7ef51e6bc044@44f68e16-4a13-4ad6-9e67-574d05c4f820@@@"
          ],
          "core_resource_type": [
            "multimedia"
          ],
          "created_at": [
            "2021-04-26T21:43:50Z"
          ],
          "updated_at": [
            "2021-04-26T22:17:00Z"
          ],
          "tipo_archivo": null,
          "tipo_recurso": null,
          "destinatario": null,
          "proceso_cognitivo": null,
          "derechos_autor": null,
          "accesibilidad": null,
          "nivel_educativo": null,
          "competencia": null,
          "disciplina": null
        },
    ]
}
}


export default mockup_internal
